import { gql } from "@apollo/client";

export const GET_SEGUIMIENTOS_FK_PAGINATED_RECLAMOS = gql`
query reclamosSDR(
    $skip: Int
    $take: Int
    $where: ReclamoSDRFilterInput  
    $order: [ReclamoSDRSortInput!]  
) {
    reclamosSDR(skip: $skip, take: $take, where: $where, order: $order)
    {
        items {
            codReclamo
            descripcion
            paciente
            fechaOcurrencia
            producto
        }
        totalCount
    }
}`;

export const adaptSeguimiento = (seguimiento) => {
  return {
    codReclamo: seguimiento.codReclamo,
    descripcion: seguimiento.descripcion,
    paciente: seguimiento.paciente,
    fechaOcurrencia: seguimiento.fechaOcurrencia,
    producto: seguimiento.producto
  };
};

export const adaptSeguimientosFKArray = (seguimientosFK) => {
  return structuredClone(seguimientosFK)?.
  map((seguimiento) => adaptSeguimiento(seguimiento));
};